import { defineStore } from 'pinia'
import { reactive } from 'vue';
import { ref, computed } from 'vue'
import { MenuItem, WebConfig } from './types';

export const useGeneralStore = defineStore('general', () => {
    const theme = ref<string>(localStorage.getItem('theme') || 'light')
    const isDarkTheme = computed(() => theme.value === 'dark');
    const webConfig = reactive<WebConfig>({
        bio: "",
        homePage: null,
        appName: null,
        baseUrl: null,
        tenantName: null,
        description: null,
        language: null,
        type: null,
        address: null,
        email: null,
        phone: null,
        logoUrl: null,
        faviconUrl: null,
        contactPerson: null,
        contactEmail: null,
        contactPhone: null,
        contactAddress: null,
        hasMembership: false,
        memberCanRegister: false,
        memberCanLogin: false,
        socialMenu: [],
        footerMenu: [],
        headerMenu: [],
        supportMenu: [],
        companyMenu: [],
        ecosystemMenu: [],
    });

    const activateTheme = () => {
        // Remove both possible classes to ensure a clean state
        document.documentElement.classList.remove('light', 'dark')
        document.documentElement.classList.add(theme.value)
    }

    const setTheme = (themeValue: string) => {
        if (theme.value) {
            document.documentElement.classList.remove(theme.value as string);
        }

        theme.value = themeValue;
        localStorage.setItem('theme', themeValue);
        activateTheme();
    }

    const loadWebConfig = async () => {
        try {
            var res = await window.$ajaxGet("/web-config");
            console.log("loadWebConfig.res", res);

            if (res) {
                if (res.webConfig) {
                    webConfig.bio = res.webConfig.bio;
                    webConfig.homePage = res.webConfig.homePage;
                    webConfig.appName = res.webConfig.appName;

                    webConfig.baseUrl = res.webConfig.baseUrl;
                    webConfig.tenantName = res.webConfig.tenantName;
                    webConfig.description = res.webConfig.description;
                    webConfig.language = res.webConfig.language;
                    webConfig.type = res.webConfig.type;
                    webConfig.email = res.webConfig.email;
                    webConfig.phone = res.webConfig.phone;
                    webConfig.logoUrl = res.webConfig.logoUrl;
                    webConfig.faviconUrl = res.webConfig.faviconUrl;
                    webConfig.contactPerson = res.webConfig.contactPerson;
                    webConfig.contactEmail = res.webConfig.contactEmail;
                    webConfig.contactPhone = res.webConfig.contactPhone;
                    webConfig.contactAddress = res.webConfig.contactAddress;
                    webConfig.hasMembership = res.webConfig.hasMembership;
                    webConfig.memberCanRegister = res.webConfig.memberCanRegister;
                    webConfig.memberCanLogin = res.webConfig.memberCanLogin;
                }

                if (res.menus && res.menus.length > 0) {
                    res.menus.forEach((menu: MenuItem) => {
                        if (menu.linkPosition === "social") {
                            webConfig.socialMenu.push(menu);
                        } else if (menu.linkPosition === "footer") {
                            webConfig.footerMenu.push(menu);
                        } else if (menu.linkPosition === "header") {
                            webConfig.headerMenu.push(menu);
                        } else if (menu.linkPosition === "support") {
                            webConfig.supportMenu.push(menu);
                        } else if (menu.linkPosition === "company") {
                            webConfig.companyMenu.push(menu);
                        } else if (menu.linkPosition === "ecosystem") {
                            webConfig.ecosystemMenu.push(menu);
                        }
                    });

                    webConfig.headerMenu.sort((a, b) => a.position - b.position);
                    webConfig.supportMenu.sort((a, b) => a.position - b.position);
                    webConfig.companyMenu.sort((a, b) => a.position - b.position);
                    webConfig.footerMenu.sort((a, b) => a.position - b.position);
                    webConfig.socialMenu.sort((a, b) => a.position - b.position);
                    webConfig.ecosystemMenu.sort((a, b) => a.position - b.position);
                }
            }
        } catch (error) {
            console.log('Error loading web config:', error);
        }
    }

    const restoreSession = async () => {
        try {
            const savedTheme = localStorage.getItem('theme')
            if (savedTheme) {
                theme.value = savedTheme
            }

            activateTheme();
        } catch (error) {
            console.log('Error restoring general store session:', error);
        }

        await window.$refreshAccessToken(window.$moduleName);
        await loadWebConfig();
    }

    const toggleTheme = () => {
        if (theme.value === 'dark') {
            setTheme('light')
        } else {
            setTheme('dark')
        }
    }

    return {
        theme,
        isDarkTheme,
        webConfig,
        setTheme,
        toggleTheme,
        restoreSession,
        loadWebConfig,
    }
})
